import { forwardRef } from 'react';
import type { LucideIcon, LucideProps } from 'lucide-react';

const MetaIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(
  ({ color = 'currentColor', ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="none"
      color={color}
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.62 18c-2.48 0-4.12-2.22-4.12-6s1.64-6 4.12-6c1.76 0 3.08 1.33 4.38 2.96C13.3 7.33 14.62 6 16.38 6c2.48 0 4.12 2.22 4.12 6s-1.64 6-4.12 6c-1.76 0-3.08-1.33-4.38-2.96C10.7 16.67 9.38 18 7.62 18Zm0-2c.86 0 1.7-.91 3.04-2.7l.08-.1-.08-.1C9.32 11.31 8.48 10 7.62 10 6.73 10 5.5 10.72 5.5 12s1.23 4 2.12 4Zm8.76 0c.89 0 2.12-2.72 2.12-4s-1.23-2-2.12-2c-.86 0-1.7 1.31-3.04 3.2l-.08.1.08.1c1.34 1.79 2.18 2.7 3.04 2.7Z"
      />
    </svg>
  ),
);

MetaIcon.displayName = 'MetaIcon';

export default MetaIcon;
